import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
    { label: "Craft", href: "#craft" },
    { label: "Pairings", href: "#pairings" },
    { label: "Concierge", href: "#concierge" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 30);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            <motion.nav
                data-testid="main-nav"
                initial={{ y: -30, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.3 }}
                className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
                    scrolled
                        ? "backdrop-blur-2xl bg-obsidian-900/70 border-b border-white/5"
                        : "bg-transparent"
                }`}
            >
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 py-5 flex items-center justify-between">
                    <a href="#top" className="flex items-center gap-3" data-testid="nav-logo">
                        <img
                            src="https://customer-assets.emergentagent.com/job_ice-craft-1/artifacts/gok5iiay_960e76ad-0bef-44cf-a65a-9b4d4d6aa7d2.jpeg"
                            alt="Chill Blox mascot"
                            className="w-9 h-9 object-cover rounded-full ring-1 ring-white/10"
                        />
                        <span className="font-serif-display text-xl tracking-tight leading-none">
                            Chill <span className="italic text-[#E63946]">Blox</span>
                            <span className="align-super text-[0.55rem] text-ice-400 ml-0.5">™</span>
                        </span>
                    </a>

                    <div className="hidden md:flex items-center gap-10">
                        {LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                data-testid={`nav-link-${l.label.toLowerCase()}`}
                                className="text-xs uppercase tracking-[0.28em] text-ice-200/70 hover:text-amber-glow transition-colors duration-300"
                            >
                                {l.label}
                            </a>
                        ))}
                    </div>

                    <a
                        href="#concierge"
                        data-testid="nav-cta"
                        className="lux-btn lux-btn-ghost text-[0.68rem]"
                    >
                        Order
                    </a>
                </div>
            </motion.nav>
        </AnimatePresence>
    );
}
